import * as Sentry from "@sentry/react";
import { createBrowserHistory } from "history";
import ReactDOM from "react-dom/client";
import "react-loading-skeleton/dist/skeleton.css";
import "react-toggle/style.css";
import App from "./App/App";
import "./App/Assets/styling/fonts.css";
import "./App/Assets/styling/var.css";
import "./tailwind.css";
import "./i18n";
import "./shared/utils/dayjs";
import { initSentry } from "./utils/Sentry";
export const history = createBrowserHistory();

initSentry();
/* initChunkErrorHandler(); */

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={null}>
    <App history={history} />
  </Sentry.ErrorBoundary>
);
